/**
 * AiFixerProgressComponent — streams real-time tool-call events.
 *
 * This component is domain-agnostic.  It receives AiJobProgressEvent[]
 * and renders them as a live log / feed.  The parent (AiFixerPanelComponent)
 * feeds it from the store.
 */
import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { AiJobProgressEvent } from '../../interfaces/ai-agent-progress-event.interface';

@Component({
    selector: 'ai-fixer-progress',
    templateUrl: './ai-fixer-progress.component.html',
    styleUrls: ['./ai-fixer-progress.component.scss'],
})
export class AiFixerProgressComponent implements OnChanges {
    /** Streaming progress events from the WebSocket */
    @Input() progressEvents: AiJobProgressEvent[] = [];

    @ViewChild('logContainer') logContainer?: ElementRef<HTMLElement>;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['progressEvents']) {
            // Auto-scroll to latest entry after view update
            setTimeout(() => {
                if (this.logContainer) {
                    this.logContainer.nativeElement.scrollTop =
                        this.logContainer.nativeElement.scrollHeight;
                }
            }, 0);
        }
    }

    /** Build a human-readable label from a progress event */
    formatEvent(event: AiJobProgressEvent): string {
        if (event.type === 'tool_call' && event.toolName) {
            const section = event.sectionKey ? `[${event.sectionKey}] ` : '';
            const errors =
                event.remainingErrors != null && event.remainingErrors >= 0
                    ? ` → ${event.remainingErrors} error(s) left`
                    : '';
            return `${section}${event.toolName}${errors}`;
        }
        if (event.message) {
            return String(event.message);
        }
        return event.type?.replace(/_/g, ' ') ?? 'Processing…';
    }

    /** TrackBy for *ngFor */
    trackByIndex(index: number): number {
        return index;
    }
}
